import { render } from "./Attachment.vue?vue&type=template&id=4e123048&scoped=true"
import script from "./Attachment.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Attachment.vue?vue&type=script&charset=utf-8&lang=js"

import "./Attachment.vue?vue&type=style&index=0&id=4e123048&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e123048"]])

export default __exports__